import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link, Element } from "react-scroll";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Heading, Text } from "@chakra-ui/react";
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";
import Login from "../Login";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (showLoginModal && sidebarOpen) {
      toggleSidebar(false);
    }
  }, [showLoginModal, sidebarOpen, toggleSidebar]);

  const handleSelected = async () => {
    try {
      await axios.post("https://glb-api.onrender.com/api/user/logout", {
        token: localStorage.getItem("token"),
      });
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      navigate("/");
      toggleSidebar(false);
      toast({
        title: "Logged out Successfully",
        description: "You have successfully logged out.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <LogoIcon />
          <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
            Review-My-SOP
          </h1>
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Home
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="services"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Services
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="projects"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Projects
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="blog"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Blog
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="pricing"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Pricing
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="contact"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Contact
          </Link>
        </li>
      </UlStyle>
      <UlStyle >
        {localStorage.getItem("token") ? (<>

          <CenteredContainer>
        <li className="semiBold font15 pointer">

          <a href="/ProfileLayout" style={{ padding: " 0" }} className="whiteColor">
            Profile
          </a>
        </li>
        <li className="semiBold font15 pointer">
        <LogoutButton onClick={handleSelected} className="radius8 lightBg" style={{ padding: "10px 15px" }}>
          Logout
        </LogoutButton>

      </li>
      </CenteredContainer>
      </>
        ) : (
          <li className="semiBold font15 pointer">
            <CenteredContainer>
            <a onClick={() => setShowLoginModal(true)} style={{ padding: " 0" }} className="whiteColor">
              Login
            </a>
            </CenteredContainer>
          </li>
        )}

      </UlStyle>
      {showLoginModal && (
        <Modal
          isOpen={showLoginModal}
          onClose={() => setShowLoginModal(false)}
        >
          <ModalOverlay />
          <ModalContent>
            {/* <ModalHeader>
              <Heading fontSize="4xl">Sign in to your account</Heading>
              <Text fontSize="lg" color="gray.600">
                to enjoy all of our cool{" "}
                <ChakraLink color="blue.400">features</ChakraLink> ✌️
              </Text>
            </ModalHeader> */}
            <ModalCloseButton />
            <ModalBody>
              <Login onClose={() => setShowLoginModal(false)}/>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </Wrapper>
  );
}


const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;

`;

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;

const LogoutButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  padding: 10px 15px;
  color: white;
  cursor: pointer;
`;
